import React, { FC, useEffect, useState } from "react";
import { TaxonomyType } from "data/types";
import CardLieuIntegre from "components/CardLieuIntegre/CardLieuIntegre";
import CardTrajetIntegre from "components/CardTrajetIntegre/CardTrajetIntegre";
import CardNuitIntegre from "components/CardNuitIntegre/CardNuitIntegre";
import ItemsSlider from 'components/ItemsSlider';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from "react-dnd-html5-backend";
import { useNavigate } from "react-router-dom";
import { JourneeType, PecType, EventType } from "data/types";
import 'react-tooltip/dist/react-tooltip.css';
import { Tooltip } from "react-tooltip";
import { useTranslation } from 'react-i18next';

export interface PlanificateurIntegreProps {
  className?: string;
  itemClassName?: string;
  categories?: TaxonomyType[];
  categoryCardType?: "card3" | "card4" | "card5";
  itemPerRow?: 4 | 5;
  sliderStyle?: "style1" | "style2";
  uniqueClassName: string;
  voyageKey: string;
  emailPartage: string;
  codePartage: string;
  mode: string;
  eventCategoriesPage: JourneeType[];
  id_pays: string;
  nbJours: number;
  visibilite: string;
  etatVoyage: number;
  nb_voyageurs: number;
  monnaie: string;
  symbole_monnaie: string,
  numDroit: number; 
  username: string;
}


const PlanificateurIntegre: FC<PlanificateurIntegreProps> = ({
  categoryCardType = "card3",
  voyageKey,
  emailPartage,
  codePartage,
  mode,
  eventCategoriesPage,
  id_pays,
  nbJours,
  visibilite,
  etatVoyage,
  nb_voyageurs,
  monnaie,
  symbole_monnaie,
  numDroit,
  username,
}) => {
  
  const { t } = useTranslation();
  
  const [eventCategories, setEventCategories] = useState<JourneeType[]>([]);
  const [loading, setLoading] = useState(true);

  const [listePec, setListePec] = useState<PecType[]>([]);

  const [journeesLoc, setJourneesLoc] = useState<any[]>([]);
  const [locationTrouve, setLocationTrouve] = useState<boolean>(false);

  let navigate=useNavigate();



  useEffect(() => {
    
    if (JSON.stringify(eventCategories) !== JSON.stringify(eventCategoriesPage)) {
      setEventCategories(eventCategoriesPage);

      console.log("eventCategoriesPage",eventCategoriesPage);
      setLoading(false); 
    }
  }, [eventCategoriesPage]);
  
    
  useEffect(() => {

    const MajPec = async () => {

    const updatedListePec = eventCategories.flatMap((day) =>
    day.evenements
      .filter(
        (event) =>
          event.location === 'O' &&
          event.moment === 'P'
      )
      .map((event) => ({
        date_journee: day.date_journee,
        id_journee: day.id_journee,
        id_evenement: event.id, 
        type_transport: event.type || "",
        rattachement: event.rattachement || "",
        debut: event.debut || ""
      }))
  );
  setListePec(updatedListePec);

  const listeJourneesLoc = eventCategories.map((day) => ({
    date_journee: day.date_journee,
    id_journee: day.id_journee,
    car: false,
    motorcycle: false,
    bicycle: false,
  }))

  setLocationTrouve(false);

  await updatedListePec.forEach((pec: any, index: number) => {
   
    if(pec.rattachement && pec.rattachement !== "" &&
       pec.type_transport && pec.type_transport !== "")
       {

          var dayDeb = eventCategories.find((day) => day.id_journee === pec.id_journee);

          if(dayDeb)
          {
            var i=dayDeb.num_jour-1;
            var trouve=false;
            var dayFin = null;
            while(i<eventCategories.length && !trouve)
            {
  
              for (let k = 0; !trouve && k < eventCategories[i].evenements.length; k++)
              {
                if(eventCategories[i].evenements[k].typeEv === "T" && eventCategories[i].evenements[k].moment && eventCategories[i].evenements[k].moment === "R" 
                && eventCategories[i].evenements[k].id.toString() === pec.rattachement)
                {
                  dayFin = eventCategories[i];
                  trouve=true;
                }
              }
              i++;
            }

            if(dayFin !== null)
            {
              for (let j = dayDeb.num_jour-1; dayFin && j <= dayFin.num_jour - 1; j++)
              {
                setLocationTrouve(true);
                switch(pec.type_transport) {
                  case 'car':
                    listeJourneesLoc[j].car=true;
                    break;
                    case 'bicycle':
                      listeJourneesLoc[j].bicycle=true;
                      break;
                      case 'motorcycle':
                        listeJourneesLoc[j].motorcycle=true;
                        break;
                }
              }
            }
          }   
       }
  })

  setJourneesLoc(listeJourneesLoc);
  }

  MajPec();
}, [eventCategories]);

const getTimelineClasses = (event: EventType) => {
  if (event.typeEv === "N") {
    return {
      iconBg: "bg-blue-50 text-blue-600 border-blue-100",
      icon: "las la-bed",
      tooltip: t("nuit"),
    };
  }

  if (event.typeEv === "T" && event.location === "O" && event.moment === "P") {
    return {
      iconBg: "bg-violet-50 text-violet-600 border-violet-100",
      icon: "las la-key",
      tooltip: t("locationPriseEnCharge"),
    };
  }
   if (event.typeEv === "T" && event.location === "O" && event.moment === "R") {
    return {
      iconBg: "bg-violet-50 text-violet-600 border-violet-100",
      icon: "las la-undo-alt",
      tooltip: t("locationRestitution"),
    };
  }

  if (event.typeEv === "T") {
    return {
      iconBg: "bg-green-50 text-green-600 border-green-100",
      icon:
        event.type && event.type !== ""
          ? `las la-${event.type}`
          : "las la-route",
      tooltip: t("trajet"),
    };
  }

  if (event.typeEv === "L" && event.type === "O") {
    return {
      iconBg: "bg-amber-50 text-amber-500 border-amber-100",
      icon: "las la-utensils",
      tooltip: t("repas"),
    };
  }

  return {
    iconBg: "bg-rose-50 text-rose-500 border-rose-100",
    icon: "las la-map-marker-alt",
    tooltip: t("lieu"),
  };
};

const IntegratedTimelineItem = ({
  event,
  children,
  isFirst,
  isLast,
  isEmptySimplifiedTransport = false,
}: {
  event: EventType;
  children: React.ReactNode;
  isFirst: boolean;
  isLast: boolean;
  isEmptySimplifiedTransport?: boolean;
}) => {
  const timeline = getTimelineClasses(event);

  return (
    <div className="relative flex gap-1 text-center pb-0">
      <div
        className="
          relative
          flex
          flex-col
          items-center
          w-6
          flex-shrink-0
          self-stretch
        "
      >
        {!isFirst && (
          <div
            className="
              absolute
              -top-3
              h-[26px]
              w-[1px]
              bg-neutral-200
            "
          />
        )}

        {!isLast && (
          <div
            className="
              absolute
              top-[24px]
              -bottom-3
              w-[1px]
              bg-neutral-200
            "
          />
        )}

        <div
          className={`
            relative
            z-10
            w-6
            h-6
            rounded-full
            flex
            items-center
            justify-center
            border
            shadow-sm
            ${timeline.iconBg}
          `}
        >
          <i
  className={`${timeline.icon} text-sm`}
  data-tooltip-id="myTooltip"
  data-tooltip-content={timeline.tooltip}
  data-tooltip-place="top"
/>
        </div>
      </div>

      <div
        className={`
          min-w-0
          flex-1
          pb-3

          ${isEmptySimplifiedTransport ? "min-h-[34px]" : ""}
        `}
      >
        {children}
      </div>
    </div>
  );
};

if (loading) {
  return <div className="text-center mt-20 mb-20"><h1 className="text-xl">{t('chargementVoyage')}</h1></div>;
}

  return (
    <DndProvider backend={HTML5Backend}>

    <ItemsSlider title="" nomClass="item-slider-container" 
    classDay="day-item-integre" classSlider="item-slider-integre"
    classBarreHaute="-integre">
        
    {eventCategories &&
              eventCategories.map((day, index) => (
               <div
  key={index}
  className="
    relative

    bg-[linear-gradient(145deg,rgba(255,255,255,0.97)_0%,rgba(255,254,255,0.95)_58%,rgba(253,250,252,0.96)_100%)]
    border
    border-[rgba(255,255,255,0.85)]
    shadow-[0_10px_28px_rgba(15,23,42,0.08)]

    rounded-[22px]

    px-2.5
    py-3

    overflow-visible
  "
>
  <>
  <div
  className="
    relative
    mb-3
    text-center
  "
>
  <div
    className="
      h-[44px]
      flex
      justify-center
    "
  >
    <div
      className="
        inline-flex
        items-start
        justify-center
        gap-2
      "
    >
      <div
        className="
          w-8
          h-8

          rounded-2xl

          bg-rose-50

          flex
          items-center
          justify-center

          text-rose-600

          shadow-sm
        "
      >
        <i className="las la-calendar text-lg" />
      </div>

      <div className="flex flex-col items-center">
        <h2
          className="
            text-xs
            font-bold
            text-neutral-900
            dark:text-white
            text-center
            leading-tight
            w-full
          "
        >
          {t("jour")} {day.num_jour}
        </h2>

        <span
          className="
            mt-0.5
            text-[10px]
            font-medium
            text-neutral-500
            dark:text-neutral-400
            text-center
            whitespace-nowrap
          "
        >
          {day.date_journee}
        </span>

        {locationTrouve && (
          <div
            className="
              mt-1
              flex
              items-center
              justify-center
              gap-1
            "
          >
            {journeesLoc[index] && journeesLoc[index].car && (
              <i
                className="las la-car text-sm text-purple-500"
                data-tooltip-id="myTooltip"
                data-tooltip-content={t("location")}
                data-tooltip-place="top"
              />
            )}

            {journeesLoc[index] && journeesLoc[index].motorcycle && (
              <i
                className="las la-motorcycle text-sm text-purple-500"
                data-tooltip-id="myTooltip"
                data-tooltip-content={t("location")}
                data-tooltip-place="top"
              />
            )}

            {journeesLoc[index] && journeesLoc[index].bicycle && (
              <i
                className="las la-bicycle text-sm text-purple-500"
                data-tooltip-id="myTooltip"
                data-tooltip-content={t("location")}
                data-tooltip-place="top"
              />
            )}
          </div>
        )}
      </div>
    </div>
  </div>
</div>
              {(() => {
  let visibleEventIndex = 0;

  return day.evenements.map((event, eventIndex) => {
  const cardContent =
    event.typeEv === "L" &&
    (
      (event.libelle1 !== null && event.libelle1 !== "") ||
      (event.libelle2 !== null && event.libelle2 !== "") ||
      (event.prix !== null && Number(event.prix.replace("", "0"))) > 0
    ) ? (
      <CardLieuIntegre
        index={`lieu-${event.id}`}
        key={`lieu-${event.id}`}
        symbole_monnaie={symbole_monnaie}
        author={{
          id: 1,
          firstName: "Alric",
          lastName: "Truelock",
          displayName: event.libelle1 || "",
          email: "atruelock0@skype.com",
          avatar: event.image || "",
          bgImage:
            "https://images.pexels.com/photos/4064835/pexels-photo-4064835.jpeg?auto=compress&cs=tinysrgb&w=500",
          count: 40,
          href: "/author",
          desc: "There’s no stopping the tech giant. Apple now opens its 100th store in China.There’s no stopping the tech giant.",
          jobName: "Author Job",
          libelle2: event.libelle2 || "",
          prix: event.prix || "",
          type: event.type || "",
          paiement: event.paiement || "",
          lien: event.lien || "",
          lien_modifie: event.lien_modifie || "",
          etat_lien: event.etat_lien || "",
          document: event.document || "",
          bloc: event.bloc || "",
          lat: event.lat || "",
          longi: event.longi || "",
          place_id: event.place || "",
        }}
        numDroit={numDroit}
      />
    ) : event.typeEv === "N" &&
      event.invisible1 !== "O" &&
      (
        (event.libelle1 !== null && event.libelle1 !== "") ||
        (event.libelle2 !== null && event.libelle2 !== "") ||
        (event.prix !== null && Number(event.prix.replace("", "0"))) > 0
      ) ? (
      <CardNuitIntegre
        index={`nuit-${event.id}`}
        key={`nuit-${event.id}`}
        symbole_monnaie={symbole_monnaie}
        author={{
          id: 1,
          firstName: "Alric",
          lastName: "Truelock",
          displayName: event.libelle1 || "",
          email: "atruelock0@skype.com",
          avatar: event.image || "",
          bgImage:
            "https://images.pexels.com/photos/4064835/pexels-photo-4064835.jpeg?auto=compress&cs=tinysrgb&w=500",
          count: 40,
          href: "/author",
          desc: "There’s no stopping the tech giant. Apple now opens its 100th store in China.There’s no stopping the tech giant.",
          jobName: "Author Job",
          libelle2: event.libelle2 || "",
          prix: event.prix || "",
          paiement: event.paiement || "",
          date_paiement_hebergement: event.date_paiement_hebergement || "",
          acompte_hebergement: event.acompte_hebergement || "",
          lien: event.lien || "",
          lien_modifie: event.lien_modifie || "",
          etat_lien: event.etat_lien || "",
          document: event.document || "",
          bloc: event.bloc || "",
          lat: event.lat || "",
          longi: event.longi || "",
          lat2: event.lat2 || "",
          longi2: event.longi2 || "",
          place_id: event.place || "",
        }}
        numDroit={numDroit}
      />
    ) : event.typeEv === "T" &&
      (
        (event.libelle1 !== null && event.libelle1 !== "") ||
        (event.libelle2 !== null && event.libelle2 !== "") ||
        (event.prix !== null && Number(event.prix.replace("", "0")) > 0) ||
        (event.type !== null && event.type !== "") ||
        (event.debut !== null && event.debut !== "") ||
        (event.fin !== null && event.fin !== "")
      ) ? (
      (() => {
        let prevEvent = null;
        let nextEvent = null;
        let simplifie = false;

        let simplifiePotentiel =
          (event.location === null ||
            event.location === "" ||
            event.location === "N") &&
          (event.prix === null ||
            event.prix === "" ||
            event.prix === "0" ||
            event.prix === "0.00");

        if (simplifiePotentiel) {
          nextEvent =
            eventIndex < day.evenements.length - 1
              ? day.evenements[eventIndex + 1]
              : undefined;

          prevEvent =
            eventIndex > 0 ? day.evenements[eventIndex - 1] : undefined;

          if (!prevEvent && index > 0) {
            const previousDay = eventCategories[index - 1];

            if (previousDay?.evenements?.length) {
              prevEvent =
                previousDay.evenements[previousDay.evenements.length - 1];

              if (
                prevEvent?.typeEv === "N" &&
                prevEvent?.invisible1 === "O" &&
                previousDay.evenements.length > 1
              ) {
                prevEvent =
                  previousDay.evenements[previousDay.evenements.length - 2];
              }
            }
          }

          let libelle1 = event.libelle1;

          if (event.invisible1 === "O") {
            libelle1 = event.libelle2;
          }

          let libelle2 = event.libelle2;

          if (prevEvent === undefined || !prevEvent) {
            if (event.libelle1 === "") {
              simplifie = true;
            }
          } else if (
            event.invisible1 === "O" ||
            libelle1 === null ||
            libelle1 === ""
          ) {
            simplifie = true;
          } else if (prevEvent.typeEv === "L") {
            if (prevEvent.libelle1 === libelle1) {
              simplifie = true;
            }
          } else if (prevEvent.typeEv === "T") {
            if (
              !prevEvent.location ||
              prevEvent.location === "" ||
              prevEvent.location === "N"
            ) {
              if (prevEvent.invisible2 === "O") {
                if (prevEvent.libelle1 === libelle1) {
                  simplifie = true;
                }
              } else if (prevEvent.libelle2 === libelle1) {
                simplifie = true;
              }
            } else {
              if (prevEvent.moment === "P") {
                if (prevEvent.libelle1 === libelle1) {
                  simplifie = true;
                }
              } else {
                if (prevEvent.libelle2 === libelle1) {
                  simplifie = true;
                }
              }
            }
          } else if (prevEvent.typeEv === "N") {
            if (
              prevEvent.libelle2 === libelle1 ||
              prevEvent.libelle1 === libelle1
            ) {
              simplifie = true;
            }
          }

          if (simplifie) {
            if (nextEvent === undefined || !nextEvent) {
              simplifie = event.libelle2 === null || event.libelle2 === "";
            } else if (
              event.invisible2 === "O" ||
              event.libelle2 === null ||
              event.libelle2 === ""
            ) {
              simplifie = true;
            } else if (nextEvent.typeEv === "L") {
              simplifie = nextEvent.libelle1 === libelle2;
            } else if (nextEvent.typeEv === "T") {
              if (
                !nextEvent.location ||
                nextEvent.location === "" ||
                nextEvent.location === "N"
              ) {
                simplifie = nextEvent.libelle1 === libelle2;
              } else {
                simplifie =
                  nextEvent.moment === "P"
                    ? nextEvent.libelle1 === libelle2
                    : nextEvent.libelle2 === libelle2;
              }
            } else if (nextEvent.typeEv === "N") {
              simplifie =
                nextEvent.libelle2 === libelle2 ||
                nextEvent.libelle1 === libelle2;
            }
          } else {
            simplifie = false;
          }
        } else {
          simplifie = false;
        }

        if (simplifie && prevEvent && nextEvent) {
          if (
            prevEvent.typeEv === "T" &&
            (!prevEvent.location || prevEvent.location !== "O")
          ) {
            simplifie = false;
          }
        }

        return (
          <CardTrajetIntegre
            index={`trajet-${event.id}`}
            key={`trajet-${event.id}`}
            symbole_monnaie={symbole_monnaie}
            author={{
              id: 1,
              firstName: "Alric",
              lastName: "Truelock",
              displayName: event.libelle1 || "",
              email: "atruelock0@skype.com",
              avatar: event.image || "",
              bgImage:
                "https://images.pexels.com/photos/4064835/pexels-photo-4064835.jpeg?auto=compress&cs=tinysrgb&w=500",
              count: 40,
              href: "/author",
              desc: "There’s no stopping the tech giant. Apple now opens its 100th store in China.There’s no stopping the tech giant.",
              jobName: "Author Job",
              libelle2: event.libelle2 || "",
              prix: event.prix || "",
              type: event.type || "",
              debut: event.debut || "",
              fin: event.fin || "",
              compagnie: event.compagnie || "",
              ref: event.ref || "",
              location: event.location || "",
              distance: event.distance || "",
              duree: event.duree || "",
              moment: event.moment || "",
              paiement: event.paiement || "",
              lien: event.lien || "",
              lien_modifie: event.lien_modifie || "",
              etat_lien: event.etat_lien || "",
              document: event.document || "",
              bloc: event.bloc || "",
              lat: event.lat || "",
              longi: event.longi || "",
              lat2: event.lat2 || "",
              longi2: event.longi2 || "",
              simplifie: simplifie,
            }}
            listePecPlanificateur={listePec}
            numDroit={numDroit}
          />
        );
      })()
    ) : null;

  if (!cardContent) {
    return null;
  }
  
const isEmptySimplifiedTransport =
  event.typeEv === "T" &&
  (event.location === null ||
    event.location === "" ||
    event.location === "N") &&
  (event.debut === null || event.debut === "") &&
  (event.fin === null || event.fin === "") &&
  (event.distance === null || event.distance === "") &&
  (event.duree === null || event.duree === "") &&
  (event.compagnie === null || event.compagnie === "") &&
  (event.ref === null || event.ref === "") &&
  (event.prix === null ||
    event.prix === "" ||
    event.prix === "0" ||
    event.prix === "0.00");

  const isFirstVisibleEvent = visibleEventIndex === 0;

visibleEventIndex++;

  return (
    <IntegratedTimelineItem
  key={eventIndex}
  event={event}
  isFirst={isFirstVisibleEvent}
  isLast={eventIndex === day.evenements.length - 1}
  isEmptySimplifiedTransport={isEmptySimplifiedTransport}
>
      {cardContent}
    </IntegratedTimelineItem>
);
  });
})()}
                </>
              </div>
            ))}


  </ItemsSlider>
    <Tooltip id="myTooltip" style={{ zIndex: 9999 }}/>
  </DndProvider>
  );
};

export default PlanificateurIntegre;
